<template>
  <div style="user-select: none;">
    <a-breadcrumb
      class="breadcrumb"
      v-if="routeList.length"
    >
      <a-breadcrumb-item
        v-for="(item, index) in routeList"
        :key="item.url"
      >
        <a
          class="cursor"
          href="javascript:;"
          v-if="(item.resolvedUrl || (item.url && !item.url.includes(':'))) && index !== routeList.length - 1"
          @click="$router.push({ path: item.resolvedUrl || item.url })"
        >
          {{item.title}}
        </a>
        <span v-else>{{item.title}}</span>
      </a-breadcrumb-item>
    </a-breadcrumb>
  </div>
</template>

<script>
import menu from '../menu.js'
import { setSession, getSession } from '@/utils'

export default {
  name: 'Breadcrumb',

  data () {
    return {
      routeList: [],
      pattern: ''
    }
  },

  mounted () {
    this.getBreadcrumb(this.$route)
  },

  watch: {
    '$route' (to, from) {
      this.getBreadcrumb(to)
    }
  },

  methods: {
    getBreadcrumb ({ matched, path }) {
      this.pattern = matched[matched.length - 1].regex
      this.routeList = path === '/' ? [] : this.handleMenu(menu)
    },
    handleMenu (array) {
      const stack = []
      let going = true
      const storeKey = 'BREADCRUMB_HISTORY'
      const history = getSession(storeKey) || []

      const walker = array => {
        array.forEach(item => {
          if (!going) return
          const m = history.find(x => x.url === item.url)
          stack.push({ ...item, ...(m ? { resolvedUrl: m.resolvedUrl } : null) })
          if (this.pattern.test(item.url)) {
            going = false
          } else if (item.children) {
            walker(item.children)
          } else {
            stack.pop()
          }
        })
        if (going) stack.pop()
      }

      walker(array)

      // 存储匹配路由的历史记录
      const empty = x => x.length === 0
      const last = x => x[x.length - 1]
      if (!empty(stack)) {
        const active = { ...last(stack), resolvedUrl: location.pathname }
        const history = getSession(storeKey) || []
        const index = history.findIndex(x => x.url === active.url)
        if (index !== -1) {
          history.splice(index, 1, { ...active })
        } else {
          history.push({ ...active })
        }
        setSession(storeKey, history)
      }

      return stack
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb {
  .wrapper;
  padding: 12px 0;
  .cursor {
    cursor: pointer;
  }
}
</style>
